import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';

export type ImportTransfersResultDto = {
  total: number;
  imported: number;
  skipped: number;
};

export const useImportTransfers = () => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<ImportTransfersResultDto, Error, File>({
    mutationFn: (file) => {
      const formData = new FormData();
      formData.append('file', file);

      return apiClient.post(`/v1/projects/${projectId}/transfers/import`, formData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transfers', projectId] });
    },
  });
};
